// Author Lin
// Date 2021-05-24 20:46:26

import * as model from "@/model/sithMes/inventory/SithMesInventoryDeliveryTaskModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory"

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesInventoryDeliveryTask(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_INVENTORY_URL,
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'partsFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'dn400Filter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'inspectionFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'orderFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'partsVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'dn400Vo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'inspectionVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'orderVo'
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'partsEntity'
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'dn400Entity'
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'inspectionEntity'
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'orderEntity'
    })
    .buildStore()
